<template>
    <div class="photo-gallery-page">
        <section
            class="hero-section"
            :style="{
                backgroundImage: `linear-gradient(180deg, rgba(5, 26, 13, 0.48), rgba(5, 26, 13, 0.78)), url('${heroBackground}')`
            }"
        >
            <NavbarSection />
            <div class="hero-overlay"></div>
            <div class="hero-content">
                <h1>Photo Gallery</h1>
                <p class="hero-text">
                    Explore curated moments from tournaments, events, and club life.
                </p>
            </div>
        </section>

        <main class="content-wrapper">
            <section class="gallery-section">
                <PhotoGallery />
            </section>

            <aside class="archive-panel">
                <div class="archive-panel__header">
                    <p class="archive-label">Archives</p>
                    <h2>Browse by month</h2>
                    <p class="archive-copy">Jump between past gallery collections with one click.</p>
                </div>

                <div class="all-media">
                    <a href="/photo-gallery">All Photos</a>
                </div>

                <ul class="archive-list">
                    <li
                        v-for="(item, index) in archives"
                        :key="index"
                    >
                        <button
                            type="button"
                            class="archive-item"
                            :class="{ active: route.query.archive === item.archive_date }"
                            @click="goToArchive(item)"
                        >
                            {{ item.archive_date }}
                        </button>
                    </li>
                </ul>
            </aside>
        </main>

        <FooterSection />
    </div>
</template>

<script setup>
import FooterSection from '@/components/FooterSection.vue';
import PhotoGallery from '@/components/PhotoGallery.vue';
import NavbarSection from '@/components/NavbarSection.vue';
import router from '@/router';
import { ref, onMounted, onBeforeUnmount } from "vue";
import axios from 'axios';
import { useRoute } from 'vue-router'
import heroBackground from '@/assets/images/HeroBg.png';

const route = useRoute()

let base_url = process.env.VUE_APP_BASE_LIVE_URL
//let base_url = "http://localhost:8888/lltc_backend/";
const dataList = ref([]);
const title = ref('');
const description = ref('');
const image = ref('');
const logoImage = ref('');
const archives = ref([]);
const dataId = ref('')

onMounted( async () => {
  dataId.value = route.params.date
  await listGallery();
  await listLogo();
  await listArchives();
});

onBeforeUnmount( async () => {
  
});

// Action methods

const listGallery = async () => {
  try {
    const response = await axios.get('/list_site_banner.php', { });
    dataList.value = response.data.data[0];
    title.value = dataList.value.title
    description.value = dataList.value.description
    image.value = `${base_url}${dataList.value.banner_image}`
    console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};
const listLogo = async () => {
  try {
    const response = await axios.get('/logo_lists.php', { });
   const logoData = response.data.data[0];
    logoImage.value = `${base_url}${logoData.banner_image}`
    console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const listArchives = async () => {
  try {
    const response = await axios.get(`/photo_gallery_archives.php`);
    archives.value = response.data.data; 
  } catch (error) {
    console.error(error.message);
  }
};
const goToArchive = (item) => {
  router.push({
    name: 'PhotoGallery',
    query: {
      archive: item.archive_date
    }
  });
};

</script>

<style lang="scss" scoped>
.photo-gallery-page {
    background: linear-gradient(180deg, #f7f8fb 0%, #ffffff 45%);
}

.hero-section {
    position: relative;
    min-height: 320px;
    border-radius: 28px;
    margin: 16px;
    overflow: hidden;
    background:
        linear-gradient(180deg, rgba(5, 26, 13, 0.48), rgba(5, 26, 13, 0.78)),
        url('@/assets/images/HeroBg.png') center/cover no-repeat;
}

.hero-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.08), rgba(9, 73, 35, 0.18));
}

.hero-content {
    position: relative;
    z-index: 1;
    max-width: 760px;
    margin: 0 auto;
    padding: 88px 24px 48px;
    text-align: center;
    color: #fff;
}

.eyebrow {
    margin: 0 0 12px;
    font-size: 12px;
    letter-spacing: 0.22em;
    text-transform: uppercase;
    opacity: 0.85;
}

.hero-content h1 {
    margin: 0;
    font-size: clamp(34px, 4vw, 54px);
    line-height: 1.05;
    font-weight: 700;
}

.hero-text {
    margin: 14px auto 0;
    max-width: 620px;
    font-size: 17px;
    line-height: 1.7;
    opacity: 0.92;
}

.content-wrapper {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 320px;
    gap: 28px;
    align-items: start;
    padding: 36px 24px 0;
    max-width: 1400px;
    margin: 0 auto;
}

.gallery-section {
    min-width: 0;
}

.archive-panel {
    position: sticky;
    top: 24px;
    align-self: start;
    background: #ffffff;
    border: 1px solid #e9edf3;
    border-radius: 22px;
    box-shadow: 0 14px 40px rgba(15, 23, 42, 0.08);
    padding: 24px;
}

.archive-panel__header {
    margin-bottom: 18px;
}

.archive-label {
    margin: 0 0 8px;
    color: #0f5b2b;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
}

.archive-panel__header h2 {
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    color: #0f172a;
}

.archive-copy {
    margin: 10px 0 0;
    color: #64748b;
    font-size: 14px;
    line-height: 1.6;
}

.all-media {
    margin-bottom: 16px;

    a {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        color: #0f5b2b;
        font-size: 14px;
        font-weight: 600;
        text-decoration: none;
    }
}

.archive-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.archive-item {
    width: 100%;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    color: #0f172a;
    border-radius: 14px;
    padding: 12px 14px;
    font-size: 14px;
    font-weight: 500;
    text-align: left;
    cursor: pointer;
    transition: transform 0.2s ease, border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;
}

.archive-item:hover {
    transform: translateY(-1px);
    border-color: #9fd5b1;
    background: #f0fbf4;
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.06);
}

.archive-item.active {
    background: #0f5b2b;
    color: #ffffff;
    border-color: #0f5b2b;
}

@media (max-width: 992px) {
    .content-wrapper {
        grid-template-columns: 1fr;
    }

    .archive-panel {
        position: static;
    }
}

@media (max-width: 768px) {
    .hero-section {
        min-height: 260px;
        margin: 12px;
        border-radius: 22px;
    }

    .hero-content {
        padding: 70px 18px 36px;
    }

    .content-wrapper {
        padding: 24px 16px 0;
        gap: 20px;
    }

    .archive-panel {
        padding: 18px;
        border-radius: 18px;
    }
}
</style>
